import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ScreenService } from '@services/screens/screen.service';
import { DataTableEvent } from '../../../components/data-table/data-table.component';

@Component({
    selector: 'app-screen-list',
    templateUrl: './screen-list.component.html',
    styleUrls: ['./screen-list.component.scss'],
    providers: [ScreenService],
    standalone: false
})
export class ScreenListComponent implements OnInit {

  @Input() customerId: string;

  public columns = [
    { prop: 'remark', name: 'Name' },
    { prop: 'assignedPackage', name: 'Package' }, // todo: is not a field -> always empty
    { prop: 'isTouch2015', name: 'Touch 2015', icon: 'check_box' }
  ];

  public params: any;

  constructor(
    public screenService: ScreenService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.params = {
      customerId: this.customerId
    };
  }

  public onDetail(event: DataTableEvent) {
    this.router.navigate(['screens', event.row._id]);
  }
}
